


























import Vue from "vue";
import RoomWizard from "@/components/organisms/wizard/RoomWizard.vue";
import WizardConnect from "@/components/organisms/wizard/WizardConnect.vue";
import { DeviceConfiguration } from "@/models/deviceConfiguration";
import VaButton from "@/components/atoms/VaButton.vue";
import SingleColumn from "@/components/templates/SingleColumn.vue";

export default Vue.extend({
  name: "template_main",
  data() {
    return {
      deviceConfiguration: undefined as DeviceConfiguration | undefined,
    };
  },
  methods: {
    onConfigUpdated(config: DeviceConfiguration) {
      this.deviceConfiguration = config;
    },
  },
  computed: {
    steps(): string[] {
      if (this.deviceConfiguration?.deviceType === "AndroidReceiver") {
        return ["license", "appearance", "complete"];
      } else {
        return [
          "license",
          "updates",
          "credentials",
          "language",
          "appearance",
          "complete",
        ];
        // TEMPORARY disabled
        // return this.deviceConfiguration?.isEssential
        //   ? [
        //       "license",
        //       "updates",
        //       "credentials",
        //       "language",
        //       "display",
        //       "appearance",
        //       "complete",
        //     ]
        //   : [
        //       "license",
        //       "updates",
        //       "credentials",
        //       "language",
        //       "appearance",
        //       "complete",
        //     ];
      }
    },
  },
  components: {
    VaButton,
    WizardConnect,
    RoomWizard,
    SingleColumn,
  },
});
